import { ICustomersUserAddressesResponse } from "@/shared/endpoints/customers";
import { Link } from "react-router-dom";
import { ABSOLUTE_ROUTES } from "@/shared/constants/routes";


const ShippingAddressBlock = ({ addresses }: { addresses: ICustomersUserAddressesResponse[] }) => {
    if (addresses?.length && addresses[0].fullAddress) {
        return (
            <div className="mt-[1.5625rem]. sm:mt-[1.875rem] flex flex-col">
                <span className="flex items-center font-atkinsonBold text-18 sm:text-24 leading-[130%] mb-[0.625rem] sm:mb-[0.9375rem]">
                    Shipping Address

                    <Link
                        to={ABSOLUTE_ROUTES.ONBOARDING.ABOUT_YOU.ADDRESS}
                        state={{ isFromReview: true }}
                        className="font-dmSansMedium font-bold ml-2.5 text-17 sm:text-19 underline text-primary leading-[130%] sm:leading-[140%] text-center"
                    >
                        Edit
                    </Link>
                </span>

                <div className="flex-col font-atkinsonHyperlegible">
                    <p className="ph-no-capture font-atkinsonHyperlegible text-[17px] sm:text-[23px] leading-[130%]">
                        {`${addresses[0].addressLine1} ${addresses[0].addressLine2 || ''}${addresses[0].unit ? `, ${addresses[0].unit}` : ''
                            }, ${addresses[0].city}, ${addresses[0].state} ${addresses[0].zip}`}
                    </p>
                </div>
            </div>
        )

    } else {
        return null;
    }
}

export default ShippingAddressBlock;